import React, { useEffect } from "react";
import "../gridAd/gridAd.scss"

const GridAd = ({ adClient, adSlot }) => {

    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.warn("AdSense error:", e);
        }
    }, []);

    return (
        <div className="gridAd">
            <div className="top">
                <div className="profilePic">
                    <span>Ad</span>
                </div>
                <div className="profileData">
                    <span className="name">Anzeige</span>
                    <span className="username">Mehr dazu</span>
                </div>
            </div>
            <ins
                data-ad-client={adClient}
                data-ad-slot={adSlot}
                data-ad-format="fluid"
                data-full-width-responsive="true"
            ></ins>
        </div>

    );
};

export default GridAd